module.exports = __webpack_public_path__ + "static/media/unblock-icon.6f4da63c.svg";